import { Validators } from '@angular/forms';
import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Custom, Textbox } from '@app/shared/dynamic-form';
import { isEmpty, result } from 'lodash';

export interface ConfigFields {
  selectTypesTpl: TemplateRef<any>;
  selectParamsTpl: TemplateRef<any>;
  selectStatusTpl: TemplateRef<any>;
  selectStatusExpedientTpl: TemplateRef<any>;
  tipo_finalizacion?: number;
  parametros?: string[];
  estado_tramite: number;
  estado_expediente: number;
}

@Injectable()
export class ManageSecondaryCompletionsFormService {
  constructor() {}

  getFields(obj?: ConfigFields): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'tipo_finalizacion',
        label: 'Tipo de finalización:',
        order: 1,
        value: !result(obj, 'obj.tipo_finalizacion') ? obj.tipo_finalizacion : null,
        template: obj.selectTypesTpl,
        placeholder: 'Tipo de finalización de la tarea.',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'parametros',
        label: 'Parametros:',
        order: 2,
        value: !isEmpty(obj.parametros) ? obj.parametros : [],
        template: obj.selectParamsTpl,
        placeholder: 'Opciones adicionales de la finalización.'
      }),
      new Textbox({
        key: 'cambioEstado',
        label: 'Cambiar etapa del trámite',
        type: 'checkbox',
        order: 3,
        value: obj.estado_tramite ? true : false,
      }),
      new Custom({
        key: 'estado',
        label: 'Cambio etapa del trámite:',
        order: 4,
        value: obj.estado_tramite ? obj.estado_tramite : null,
        template: obj.selectStatusTpl,
        placeholder: 'Seleccione la etapa del trámite por el cual se desea cambiar.',
        condictions: [
          {
            campoDepende: 'cambioEstado',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ]
      }),
      new Textbox({
        key: 'cambioEstadoExpediente',
        label: 'Cambiar estado del expediente',
        type: 'checkbox',
        order: 5,
        value: obj.estado_expediente ? true : false,
      }),
      new Custom({
        key: 'estadoExpediente',
        label: 'Cambio estado del expediente:',
        order: 6,
        value: obj.estado_expediente ? obj.estado_expediente : null,
        template: obj.selectStatusExpedientTpl,
        placeholder: 'Seleccione el estado del expediente por el cual se desea cambiar.',
        condictions: [
          {
            campoDepende: 'cambioEstadoExpediente',
            siEs: 'Igual',
            valor: 'true',
            accion: 'Mostrar'
          }
        ]
      }),
    ];
    // Ordenar los campos segun su propiedad order
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-secondary-completions/shared/manage-secondary-completions.form.service.ts